import styled from 'styled-components';

export const ContainerMain = styled.div`
  align-items: center;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
`;

export const FirstStrip = styled.div`
  align-items: flex-end;
  background-color: #000000;
  display: flex;
  height: 3.71vh;
  justify-content: center;
  width: 100vw;
`;

export const TextFirstStrip = styled.p`
  color: #ffffff;
  font-family: 'Outfit', sans-serif;
  font-size: 1.23vh;
  font-weight: 400;
  margin-bottom: 0.5vh;
`;

export const ContainerReset = styled.div`
  align-items: center;
  background-color: #fafafa;
  border-radius: 2vh;
  border: 0.1vh solid #efefef;
  display: flex;
  flex-direction: column;
  height: 88.2vh;
  margin-top: 1.2vh;
  position: relative;
  width: 93.6vw;
`;

export const ContainerShieldText = styled.div`
  align-items: center;
  display: flex;
  height: 2vh;
  justify-content: space-between;
  left: 2vh;
  position: absolute;
  top: 3vh;
  width: 14.5vh;
`;

export const IconShield = styled.img`
  height: 1.98vh;
  width: 1.85vh;
`;

export const TextShield = styled.p`
  color: #000000;
  font-family: 'Libre Franklin', sans-serif;
  font-size: 1.5vh;
  font-weight: 400;
`;

export const LogoResolva = styled.img`
  height: 8.42vh;
  margin-top: 11vh;
  width: 6.1vh;
`;

export const Title = styled.h1`
  color: #000000;
  font-family: 'Outfit', sans-serif;
  font-size: 2.72vh;
  font-weight: 700;
  margin-top: 2vh;
`;

export const SubTitle = styled.p`
  color: #000000;
  font-family: 'Libre Franklin', sans-serif;
  font-size: 1.92vh;
  font-weight: 400;
  margin-bottom: 3vh;
  margin-top: 1vh;
  text-align: center;
  width: 60vw;
`;

export const ContainerLabelInput = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2vh;
`;

export const LabelInput = styled.p`
  color: #000000;
  font-family: 'Libre Franklin', sans-serif;
  font-size: 1.48vh;
  font-weight: 400;
  margin-bottom: 0.5vh;
`;

export const ContainerInputIcon = styled.div`
  align-items: center;
  display: flex;
  position: relative;
`;

export const Input = styled.input`
  border-radius: 1.3vh;
  border-style: none;
  border: 0.1vh solid #000000;
  box-sizing: border-box;
  height: 6.07vh;
  padding-left: 4vh;
  width: 83.7vw;
`;

export const IconInput = styled.img`
  height: 1.85vh;
  left: 1.5vh;
  position: absolute;
  width: 1.85vh;
`;

export const Button = styled.button`
  background-color: ${(props) => (props.disabled ? '#cccccc' : '#000000')};
  border-radius: 1.3vh;
  border-style: none;
  color: #ffffff;
  font-family: 'Outfit', sans-serif;
  font-size: 2.6vh;
  font-weight: 700;
  height: 6.07vh;
  margin-top: 2vh;
  width: 83.7vw;
`;
